import { type FunctionalComponent, h } from '@stencil/core';
import type { ConversationalSearchProductHierarchy } from '../../../conversational-search-types/conversational-search-types.type';
import type { labelProviderInterface } from '../../../../../LabelProviderInterface';

export interface IConversationalSearchProductHierarchyWrapper {
  hierarchy: ConversationalSearchProductHierarchy;
  labelProvider: labelProviderInterface;
  query: string;
  language: string;
}

export const ConversationalSearchProductHierarchyWrapper: FunctionalComponent<
  IConversationalSearchProductHierarchyWrapper
> = (props) => {
    const isParentDataPresent =
      props.hierarchy &&
      props.hierarchy?.title;

    const isDifferentCategoryView = !isParentDataPresent && props?.hierarchy?.subLevels?.length > 1;

    return (
      <div class='conversational-search-product-hierarchy-wrapper'
      >
        {isParentDataPresent ? (
          <uiaas-search-conversational-search-messages-product-hierarchy
            labelProvider={(e, f) => props.labelProvider(e, f)}
            query={props.query}
            parentData={props.hierarchy}
            isParentData={true}
            childrenData={props.hierarchy.subLevels}
            language="en"
          />
        ) : (
          <section>
            {props.hierarchy?.subLevels.map((subLevel, index) => (
              <div>
                <uiaas-search-conversational-search-messages-product-hierarchy
                  labelProvider={(e, f) => props.labelProvider(e, f)}
                  query={props.query}
                  parentData={subLevel}
                  childrenData={subLevel?.subLevels}
                  isDifferentCategory={isDifferentCategoryView}
                  language={props.language}
                />
                {index < props.hierarchy.subLevels.length - 1 && (
                  <qds-divider />
                )}
              </div>
            ))}
          </section>
        )}
      </div>
    );
};
